import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
// import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import DepartmentSectionStyle2 from '../Section/DepartmentSection/DepartmentSectionStyle2';
import FeaturesSectionStyle2 from '../Section/FeaturesSection/FeaturesSectionStyle2';
import FunFactSection from '../Section/FunFactSection';
// import TeamSection from '../Section/TeamSection';
// import GallerySection from '../Section/GallerySection';
import AwardSectionStyle2 from '../Section/AwardSection/AwardSectionStyle2';
import { pageTitle } from '../../helpers/PageTitle';
import BrandsCarousel from '../Slider/BrandsCarousel';
import BlogSection from '../Section/BlogSection';
import { Helmet } from 'react-helmet-async';
// import HyperHypothermiaUnit from './HyperHypothermiaUnit';
// import MercuryMini from './MercuryMini';

const departmentData = [
  {
    title: 'Hyper-Hypothermia Unit',
    subTitle: 'Advanced unit for precise temperature control, ensuring optimal patient care.',
    // iconUrl: '/images/icons/Hyper Hypothermia Unit.png',
    iconUrl: '/images/icons/Hyper Hypothermia Unit.png',
    href: '/HyperHypothermiaUnit',
  },
  {
    title: 'Mercury Mini',
    subTitle: 'Compact heater with touch control, precise temperature, and 5-liter capacity.',
    // iconUrl: '/images/icons/MERCURY MINI.png',
    iconUrl: '/images/icons/MERCURY MINI.png',
    href: '/MercuryMini',
  },
  {
    title: 'Mercury Magma',
    subTitle: 'Efficient heater with touch control, 5-liter capacity, and wide temperature range.',
    // iconUrl: '/images/icons/Mercury Magma.png',
    iconUrl: '/images/icons/Mercury Magma.png',
    href: '/MercuryMagma',
  },
  {
    title: 'Mercury Slush',
    subTitle: 'Slush unit with auto-stir, easy maintenance, and minimal tissue trauma.',
    // iconUrl: '/images/icons/Mercury Slush.png',
    iconUrl: '/images/icons/Mercury Slush.png',
    href: '/MercurySlush',
  },
  {
    title: 'Mercury-S1-Sternum-Saw',
    subTitle: 'Advanced sternum saw with precise cutting, ensuring efficient surgical procedures.',
    // iconUrl: '/images/icons/S1  Sternum Saw.png',
    iconUrl: '/images/icons/S1  Sternum Saw.png',
    href: '/Mercury-S1-Sternum-Saw',
  },
];

const featureListData = [
  {
    title: 'Our Vision',
    subTitle: 'At Mercury Healthcare, our vision is to design and develop advanced, feature-rich medical equipment in India, combining global expertise to deliver affordable, high-quality healthcare solutions.',
    // iconUrl: 'images/icons/professional.svg',
    iconUrl: 'images/icons/professional.svg',
  },
  {
    title: 'Our Strength',
    subTitle: 'Our strength lies in our ability to create high-tech medical equipment with innovative features, leveraging global experience to offer reliable and cost-effective healthcare solutions.',
    // iconUrl: 'images/icons/comprehensive.svg',
    iconUrl: 'images/icons/comprehensive.svg',
  },
  {
    title: 'Our Mission',
    subTitle: 'Our mission is to manufacture cutting-edge medical equipment in India, integrating advanced technology to provide accessible and high-quality healthcare solutions globally.',
    // iconUrl: 'images/icons/patient.svg',
    iconUrl: 'images/icons/patient.svg',
  },
  {
    title: 'Our Values',
    subTitle: 'Our values focus on innovation, quality, and affordability, driving us to deliver advanced medical equipment that meets the highest standards of care and accessibility.',
    // iconUrl: 'images/icons/facilities.svg',
    iconUrl: 'images/icons/facilities.svg',
  },
];

const funFactData = [
  { number: '20+', title: 'Years of Experience' },
  { number: '95%', title: 'Patient Satisfaction' },
  { number: '5000+', title: 'Patients Annually' },
  { number: '10+', title: 'Top-Quality Service' },
  { number: '22+', title: 'Accessible Locations' },
];

// const teamData = [
//   {
//     imgUrl: 'images/about/doctor_1.png',
//     name: 'Dr. James Lee, MD',
//     designation: 'Head of Cardiologist',
//     description: 'With expertise in managing complex heart conditions and performing advanced cardiac procedures',
//     social: [
//       { icon: 'fa6-brands:facebook-f', href: '/about' },
//       { icon: 'fa6-brands:linkedin-in', href: '/about' },
//       { icon: 'fa6-brands:twitter', href: '/about' },
//     ],
//   },
//   {
//     imgUrl: 'images/about/doctor_2.png',
//     name: 'Dr. John Smith, MD',
//     designation: 'Emergency Medicine Physician',
//     description: 'With expertise in treating acute illnesses and injuries in medicine physician',
//     social: [
//       { icon: 'fa6-brands:facebook-f', href: '/about' },
//       { icon: 'fa6-brands:linkedin-in', href: '/about' },
//       { icon: 'fa6-brands:twitter', href: '/about' },
//     ],
//   },
//   {
//     imgUrl: 'images/about/doctor_3.png',
//     name: 'Dr. Susan Bones, MD',
//     designation: 'Board-certified Pediatrician',
//     description: 'With experience in managing complex medical conditions in children',
//     social: [
//       { icon: 'fa6-brands:facebook-f', href: '/about' },
//       { icon: 'fa6-brands:linkedin-in', href: '/about' },
//       { icon: 'fa6-brands:twitter', href: '/about' },
//     ],
//   },
// ];

// const galleryData = [
//   { imgUrl: '/images/about/portfolio_2_lg.jpeg' },
//   { imgUrl: '/images/about/portfolio_3_lg.jpeg' },
//   { imgUrl: '/images/about/portfolio_1_lg.jpeg' },
//   { imgUrl: '/images/about/portfolio_4_lg.jpeg' },
//   { imgUrl: '/images/about/portfolio_5_lg.jpeg' },
// ];


const blogData = [
  {
    // thumbUrl: "images/home_1/1.png"
    thumbUrl: "images/home_1/1.png"
  },
  {
    // thumbUrl: "images/home_1/2.png" 
    thumbUrl: "images/home_1/2.png"
  },
  {
    // thumbUrl: "images/home_1/3.png" 
    thumbUrl: "images/home_1/3.png"
  },
  {
    //  thumbUrl: "images/home_1/4.png"
    thumbUrl: "images/home_1/4.png"

  },
];




const awardData = [
  {
    title: "Soma Technology Inc",
    subTitle: "166 Highland Park Dr, Bloomfield, CT 06002, USA",
    // iconUrl: "images/icons/1.png",
    iconUrl: "images/icons/1.png",
    url: "https://www.somatechnology.com",
  },
  {
    title: "Axia Surgical LLC",
    subTitle: "Connecticut, USA",
    // iconUrl: "images/icons/2.png",
    iconUrl: "images/icons/2.png",
    url: "https://www.axiasurgical.com/",
  },
  {
    title: "Seattle Technology",
    subTitle: "3915 152nd Street NE, Marysville, WA 98271, USA",
    // iconUrl: "images/icons/3.png",
    iconUrl: "images/icons/3.png",
    url: "https://stsurg.com/",
  },
  {
    title: "Soma Health Care (FZC)",
    subTitle: "125 M2 Warehouse, Q3-214 Saif-Zone, Sharjah, UAE",
    // iconUrl: "images/icons/4.png",
    iconUrl: "images/icons/4.png",
    url: "https://www.somauae.com/",
  },
  {
    title: "Soma Tech Intl Inc",
    subTitle: "166 Highland Park Dr, Bloomfield, CT 06002, USA",
    // iconUrl: "images/icons/5.png",
    iconUrl: "images/icons/5.png",
    url: "https://www.somatechnology.com",
  },
  {
    title: "Octopus Medical Technologies Pvt. Ltd",
    subTitle: "Plot 44, Siddhi Ind. Park Waghodia, Vadodara-391760, India.",
    // iconUrl: "images/icons/6.png",
    iconUrl: "images/icons/6.png",
    url: "https://www.octopusmed.com/",
  },
];
export default function About() {
  pageTitle('About');
  return (
    <>
      <Helmet>
        <title>A Leading Exporters from India [Specialized in Hyper-Hypothermia Machine]</title>
        <meta name="Keyword" content="Fast Cooling machine exporters in India, Hypothermia Machine Supplier in India, Hyper-Hypothermia Machine Manufacture in India, Hyper-Hypothermia Machine Manufacture in Vadodara" />
        {/* Google Analytics Tracking Code */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"></script>
        <script>
          {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-MGF4V7P4YB');
    `}
        </script>
      </Helmet>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.svg"
        // imgUrl="/images/about/Single Product Image for Home Page Size - 1071 by 934.png"
        imgUrl="/images/about/Single Product Image for Home Page Size - 1071 by 934.png"
        title="Welcome to <br />Mercury HealthCare"
        subTitle="Mercury Healthcare blends expert knowledge with innovative technology to create advanced medical equipment, setting new benchmarks in patient care and clinical precision."
      />
      {/* <Section topMd={200} topLg={150} topXl={110}>
        <DepartmentSectionStyle2
          sectionTitle="Provides Our Best Products"
          sectionTitleUp="Our Products"
          data={departmentData}
        /> 
      </Section> */}
      <Section topMd={175} topLg={125} topXl={85} bottomMd={100} bottomLg={110}>
        <FeaturesSectionStyle2
          sectionTitle="Why Choose Us"
          // imgUrl="images/about/Why choose us 570x764.png"
          imgUrl="images/about/Why choose us 570x764.png"
          data={featureListData}
        />
      </Section>
      {/* <Section>
        <FunFactSection
          bgUrl="images/about/fun_fact_bg.jpeg"
          data={funFactData}
        />
      </Section> */}
      {/* Uncomment the following section if you want to include it */}
      {/* <Section topMd={190} topLg={145} topXl={105}>
        <TeamSection
          sectionTitle="Experts Doctor"
          sectionTitleUp="MEET OUR"
          data={teamData}
        />
      </Section> */}
      {/* Uncomment the following section if you want to include it */}
      {/* <Section topMd={170} topLg={120} topXl={80}>
        <GallerySection
          sectionTitle="Our Facilities and <br />Latest Activities"
          sectionTitleUp="HAVE A LOOK AT"
          data={galleryData}
        />
      </Section> */}
      <Section
        topMd={10}
        topLg={10}
        topXl={10}
        bottomMd={10}
        bottomLg={10}
        bottomXl={10}
      >
        <BrandsCarousel sectionTitle="Business Association" data={awardData} />
      </Section>
      {/* Uncomment the following section if you want to include it */}
      {/* <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="images/about/banner_bg_2.jpeg"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
          center
        />
      </Section> */}

      <Section topMd={50} topLg={50} topXl={50}>
        <BlogSection sectionTitle="Certifications" data={blogData} />
      </Section>
    </>
  );
}
